import { createContext, useContext } from "react";

// hasSoviAi  — controls whether the toolbar panel is rendered at all (module: sovi_ai)
// hasAskSovi — controls whether Ask Sovi buttons and Diagnose banner are shown (module: ask_sovi)
export const SoviAiContext = createContext({ hasSoviAi: null, hasAskSovi: false });

export const useSoviAi = () => useContext(SoviAiContext);
